import type {
	SRT_ColumnDef,
	SRT_Row,
	SRT_RowData,
	SRT_SortingState,
} from '@/shared/components/master-table'

import React, { useState } from 'react'

import { useMasterReactTable } from '@/shared/components/master-table'
import { getMasterTableLocale } from '@/shared/i18n'

type TableViewProps<T extends SRT_RowData> = {
	rows: T[]
	columns: SRT_ColumnDef<T, any>[]
	isLoading: boolean
	className?: string
	getRowId: (row: T) => string
	getRowHeight?: (row?: SRT_Row<T>) => number
}
export function useWidgetTable<T extends SRT_RowData>({
	className = 'h-96',
	rows,
	columns,
	isLoading,
	getRowId,
	getRowHeight,
}: TableViewProps<T>) {
	const [sorting, setSorting] = useState<SRT_SortingState>([])

	return useMasterReactTable<T>({
		localization: getMasterTableLocale(),
		data: rows,
		columns,
		state: {
			isLoading,
			sorting,
		},
		defaultColumn: {
			minSize: 28,
			size: Number.MAX_SAFE_INTEGER,
			maxSize: Number.MAX_SAFE_INTEGER,
		},
		getRowId,
		getRowHeight,
		layoutMode: 'grid',
		enableColumnActions: false,
		enableColumnFilters: true,
		enableColumnPinning: true,
		enableColumnResizing: true,
		enableVirtualization: true,
		getRowClassName: () => 'h-7',
		onSortingChange: setSorting,
		defaultRowHeight: 30,
	})
}
